import { Drawer } from 'theme';

var createCartPromise = () => {
  return new Promise(async (resolve) => {
    resolve(await (await fetch(`${Shopify.routes.root}cart.js`)).json());
  });
};

class TiltEffect {
  constructor(element) {
    this.el = element;
    this.width = this.el.clientWidth;
    this.height = this.el.clientHeight;
    this.initEvents();
  }

  initEvents() {
    this.el.addEventListener('mousemove', (e) => this.handleMove(e));
    this.el.addEventListener('mouseout', () => this.resetTransform());
    this.el.addEventListener('mousedown', () => this.shrink());
    this.el.addEventListener('mouseup', () => this.expand());
  }

  handleMove(e) {
    const xVal = e.layerX;
    const yVal = e.layerY;
    const yRotation =
      this.el.getAttribute('data-tilt-amount') ||
      20 * ((xVal - this.width / 2) / this.width);
    const xRotation =
      this.el.getAttribute('data-tilt-amount') ||
      -20 * ((yVal - this.height / 2) / this.height);
    this.applyTransform(xRotation, yRotation, 1.1);
  }

  applyTransform(xRotation, yRotation, scale) {
    this.el.style.transform = `perspective(500px) scale(${scale}) rotateX(${xRotation}deg) rotateY(${yRotation}deg)`;
  }

  resetTransform() {
    this.applyTransform(0, 0, 1);
  }

  shrink() {
    this.applyTransform(0, 0, 0.9);
  }

  expand() {
    this.applyTransform(0, 0, 1.1);
  }
}

class ParentTiltHandler {
  constructor(parentSelector) {
    this.parents = document.querySelectorAll(parentSelector);
    this.initEvents();
  }

  initEvents() {
    this.parents.forEach((parent) => {
      parent.addEventListener('mousemove', (e) => this.handleMove(e, parent));
      parent.addEventListener('mouseout', () => this.resetTransform(parent));
      parent.addEventListener('mousedown', () => this.shrink(parent));
      parent.addEventListener('mouseup', () => this.expand(parent));
    });
  }

  handleMove(e, parent) {
    const targetSelector = parent.getAttribute('data-target');
    const target = parent.querySelector(targetSelector);
    if (!target) return;

    const { width, height } = target.getBoundingClientRect();
    const xVal = e.offsetX;
    const yVal = e.offsetY;
    const tiltAmount = parent.getAttribute('data-tilt-amount') || 20;
    const yRotation = tiltAmount * ((xVal - width / 2) / width);
    const xRotation = -tiltAmount * ((yVal - height / 2) / height);
    target.style.transform = `perspective(500px) scale(1.1) rotateX(${xRotation}deg) rotateY(${yRotation}deg)`;
  }

  resetTransform(parent) {
    const target = parent.querySelector(parent.getAttribute('data-target'));
    if (target)
      target.style.transform =
        'perspective(500px) scale(1) rotateX(0) rotateY(0)';
  }

  shrink(parent) {
    const target = parent.querySelector(parent.getAttribute('data-target'));
    if (target)
      target.style.transform =
        'perspective(500px) scale(0.9) rotateX(0) rotateY(0)';
  }

  expand(parent) {
    const target = parent.querySelector(parent.getAttribute('data-target'));
    if (target)
      target.style.transform =
        'perspective(500px) scale(1.1) rotateX(0) rotateY(0)';
  }
}

// Apply tilt effect to all elements with attribute 'data-tilt'
document.querySelectorAll('[data-tilt]').forEach((el) => new TiltEffect(el));

// Apply tilt effect to all parent elements with 'data-target' attribute
new ParentTiltHandler('[data-tilt-parent]');

class PageProgress extends HTMLElement {
  constructor() {
    super();
    this.sections = [];
    this.observer = null;
    this.activeButton = null;
    this.swiperSlider = this.querySelector('swiper-slider');
    this.targetContainer =
      this.querySelector(this.getAttribute('selector')) || this;
  }

  connectedCallback() {
    window.addEventListener('load', () => {
      this.render();
      this.observeSections();
    });
  }

  render() {
    const anchors = document.querySelectorAll('[data-anchor-handle]');

    if (!this.targetContainer) {
      console.error('Target container not found');
      return;
    }

    this.targetContainer.innerHTML = ''; // Clear previous content
    this.sections = []; // Reset sections

    anchors.forEach((anchor, index) => {
      const li = document.createElement('li');
      li.classList.add('swiper-slide');
      li.setAttribute('data-swiper-slide', '');
      const anchorButton = document.createElement('anchor-button');
      const targetId = anchor.closest('.shopify-section')?.id;

      if (!targetId) {
        console.error('Target ID is missing or invalid for anchor', anchor);
        return;
      }

      anchorButton.setAttribute('data-target', `#${targetId}`);
      anchorButton.innerHTML = `<button class="button button--sm button--outline button--outline--faded" data-anchor-button="${targetId}">
        ${anchor.getAttribute('data-anchor-name')}
      </button>`;

      li.appendChild(anchorButton);
      this.targetContainer.appendChild(li);

      const button = anchorButton.querySelector('button');

      button.addEventListener('click', (event) => {
        event.preventDefault();
        this.userInteracting = true; // Prevent automatic goToSlide
        // document.getElementById(targetId)?.scrollIntoView({ behavior: 'smooth' });

        setTimeout(() => {
          this.userInteracting = false; // Re-enable auto slide updates after some time
        }, 1500); // Adjust time to match scrolling animation
      });

      this.sections.push({
        id: targetId,
        button: button,
        element: document.getElementById(targetId),
      });
    });

    this.classList.remove('hidden');
    this.initializeSlider();
  }

  initializeSlider() {
    if (!this.swiperSlider) return;
    this.swiperSlider.initializeSwiper();
  }

  observeSections() {
    if (this.sections.length === 0) return;

    const isVertical = window.innerHeight > window.innerWidth;
    const thresholdValue = isVertical ? [0.5] : [0.8]; // Adjust values as needed

    if (this.observer) {
      this.observer.disconnect(); // Remove old observer before reinitializing
    }

    this.observer = new IntersectionObserver(
      (entries) => {
        let mostVisibleSection = null;
        let highestVisibility = 0;

        entries.forEach((entry) => {
          const sectionId = entry.target.id;
          const section = this.sections.find((s) => s.id === sectionId);

          if (entry.isIntersecting) {
            if (entry.intersectionRatio > highestVisibility) {
              mostVisibleSection = entry.target;
              highestVisibility = entry.intersectionRatio;
            }
          }

          if (
            sectionId === this.sections[0].id &&
            entry.boundingClientRect.top > 0
          ) {
            section.button.removeAttribute('active');
          } else if (
            sectionId === this.sections[this.sections.length - 1].id &&
            entry.boundingClientRect.top < 0
          ) {
            section.button.removeAttribute('active');
          }
        });

        if (mostVisibleSection) {
          this.handleActiveState(mostVisibleSection, highestVisibility);
        }
      },
      { threshold: thresholdValue }
    );

    this.sections.forEach((section) => {
      if (section.element) {
        this.observer.observe(section.element);
      }
    });
  }

  // Reinitialize observer on window resize
  handleResize() {
    clearTimeout(this.resizeTimeout);
    this.resizeTimeout = setTimeout(() => {
      this.observeSections();
    }, 300); // Debounce to avoid frequent calls
  }

  connectedCallback() {
    window.addEventListener('load', () => {
      this.render();
      this.observeSections();
    });

    window.addEventListener('resize', this.handleResize.bind(this));
  }

  handleActiveState(mostVisibleSection, highestVisibility) {
    // Remove active attribute for all buttons first
    this.sections.forEach((section) =>
      section.button.removeAttribute('active')
    );

    const activeIndex = this.sections.findIndex(
      (section) => section.id === mostVisibleSection.id
    );

    if (activeIndex !== -1) {
      const currentSection = this.sections[activeIndex];

      // If visibility is less than 50% and it's the last section, remove active state
      if (activeIndex === this.sections.length - 1 && highestVisibility < 0.5) {
        currentSection.button.removeAttribute('active');
      } else {
        currentSection.button.setAttribute('active', '');
      }

      if (!this.userInteracting && activeIndex !== -1) {
        this.swiperSlider.goToSlide(activeIndex);
      }
    }
  }

  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }
}

customElements.define('page-progress', PageProgress);

class AnchorButton extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.button = this.querySelector('button');
    if (this.button) {
      this.button.addEventListener('click', this.scrollToTarget.bind(this));
    }
  }

  scrollToTarget() {
    const targetId = this.getAttribute('data-target');
    if (targetId) {
      const targetElement = document.querySelector(targetId);
      if (targetElement) {
        // Get the --header-height value from the body
        const headerHeight =
          parseInt(
            getComputedStyle(document.body).getPropertyValue('--header-height')
          ) || 0;

        // Calculate the scroll position
        const targetPosition =
          targetElement.getBoundingClientRect().top + window.scrollY;
        window.scrollTo({
          top: targetPosition - headerHeight,
          behavior: 'smooth',
        });
      }
    }
  }
}

customElements.define('anchor-button', AnchorButton);

class UGCVideoModal extends HTMLElement {
  constructor() {
    super();
    this.activeModal = null;
    this.activeVideos = [];
    this.swiperSlider = null;
    this.volumeButton = null;
  }

  connectedCallback() {
    this.initModalTriggers();
    this.initVolumeButton();
    document.addEventListener('click', this.handleOutsideClick.bind(this));
  }

  initModalTriggers() {
    document.querySelectorAll('[modal-trigger]').forEach((button) => {
      button.addEventListener(
        'click',
        this.handleModalTriggerClick.bind(this, button)
      );
    });
  }

  initVolumeButton() {
    this.volumeButton = this.querySelector('[volume-trigger]');
    if (this.volumeButton) {
      this.volumeButton.addEventListener('click', this.toggleVolume.bind(this));
    } else {
      console.warn('Volume button not found.');
    }
  }

  handleModalTriggerClick(button, event) {
    event.stopPropagation();
    const modal = document.getElementById(button.getAttribute('modal-id'));
    const targetIndex = Number(button.getAttribute('target-index')) || 0;
    if (modal) {
      this.activeModal === modal
        ? this.closeModal()
        : this.openModal(modal, targetIndex);
    }
  }

  handleOutsideClick(event) {
    if (this.activeModal && !event.target.closest('.ugc-popup__body')) {
      this.closeModal();
    }
  }

  openModal(modal, targetIndex) {
    if (!modal) return;
    this.destroyPageScroll();
    this.closeModal();
    this.activeModal = modal;
    this.activeVideos = Array.from(modal.querySelectorAll('video-media'));
    this.swiperSlider = modal.querySelector('swiper-slider');
    document.body.classList.add('scroll-hidden--mobile');
    modal.setAttribute('open', '');

    if (this.swiperSlider && targetIndex > 0) {
      this.swiperSlider.goToSlide(targetIndex - 1);
    }

    setTimeout(() => {
      this.playVideo(targetIndex - 1);
      this.destroyPageScroll();
      this.setVideosVolume(0.35);
      this.volumeButton.removeAttribute('muted');
    }, 200);
  }

  playVideo(index) {
    const video = this.activeVideos[index];
    if (video) {
      video.disableControls();
      video.play();
    }
  }

  destroyPageScroll() {
    const x = window.scrollX;
    const y = window.scrollY;
    window.scrollTo(x, y);
  }

  toggleVolume() {
    const isMuted = this.volumeButton.hasAttribute('muted');

    if (isMuted) {
      this.setVideosVolume(0.35);
      this.volumeButton.removeAttribute('muted');
    } else {
      // Mute: Set volume to 0
      this.setVideosVolume(0);
      this.volumeButton.setAttribute('muted', 'true');
    }
  }

  closeModal() {
    if (!this.activeModal) return;

    document.body.classList.remove('scroll-hidden--mobile');
    this.activeModal.removeAttribute('open');

    setTimeout(() => {
      this.pauseAllVideos();
      this.muteAllVideos();
      this.activeModal = null;
    }, 200);
  }

  setVideosVolume(newVolume) {
    this.activeVideos.forEach((video) => {
      const videoEl = video.querySelector('video');
      if (newVolume === 0) {
        videoEl.muted = true; // Mute the video
      } else {
        videoEl.muted = false; // Unmute the video
        videoEl.volume = newVolume; // Set the volume
      }
    });
  }

  pauseAllVideos() {
    this.activeVideos.forEach((video) => video.pause());
  }

  muteAllVideos() {
    this.setVideosVolume(0);
    this.volumeButton.setAttribute('muted', 'true');
  }
}

customElements.define('ugc-video-modal', UGCVideoModal);

class SiteTabs extends HTMLElement {
  constructor() {
    super();
    this.activeTab = null;
    this.activeTabContent = null;
    this.shouldScroll = this.hasAttribute('scroll-to-content');
  }

  connectedCallback() {
    this.initTabs();
    this.attachEvents();
  }

  initTabs() {
    this.tabTriggers = [...this.querySelectorAll('[tab-trigger]')];
    this.tabContents = [...this.querySelectorAll('[tab-content]')];

    const initiallyActiveTab = this.tabTriggers.find((tab) =>
      tab.hasAttribute('active')
    );
    if (initiallyActiveTab) {
      this.activeTab = initiallyActiveTab;
    } else {
      this.activeTab = this.tabTriggers.length ? this.tabTriggers[0] : null;
    }

    this.activeTabContent = this.getTabContent(this.activeTab);
  }

  attachEvents() {
    this.tabTriggers.forEach((trigger) => {
      trigger.addEventListener('click', () => this.handleTabClick(trigger));
    });
  }

  handleTabClick(newTab) {
    if (newTab === this.activeTab) return;
    this.setActiveTab(newTab);
  }

  setActiveTab(tab) {
    if (!tab) return;

    this.clearActiveStates();
    this.activeTab = tab;
    this.activeTabContent = this.getTabContent(tab);

    if (this.activeTab && this.activeTabContent) {
      this.activeTab.setAttribute('active', '');
      this.activeTabContent.setAttribute('open', '');
      this.updateWrapperState(tab, true);
      this.scrollToContent();
    }
  }

  clearActiveStates() {
    this.tabTriggers.forEach((tab) => {
      tab.removeAttribute('active');
      this.updateWrapperState(tab, false);
    });
    this.tabContents.forEach((content) => {
      content.removeAttribute('open');
    });
  }

  getTabContent(tab) {
    return this.querySelector(
      `[tab-content="${tab.getAttribute('tab-trigger')}"]`
    );
  }

  updateWrapperState(tab, isActive) {
    const wrapper = tab.closest('[tab-trigger-wrapper]');
    if (wrapper) {
      wrapper.toggleAttribute('tab-trigger-active', isActive);
    }
  }

  scrollToContent() {
    if (this.shouldScroll && this.activeTabContent) {
      this.activeTabContent.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }
  }
}

customElements.define('site-tabs', SiteTabs);

class CategoryFilters extends HTMLElement {
  constructor() {
    super();
    this.filterButtons = this.querySelectorAll('button[data-category-button]');

    this.filterButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const targetCollectionURL = button.dataset.targetUrl;
        // Switch the collection content as before
        this.switchCollectionContent(targetCollectionURL);
        // Dispatch the global event to update active state
        this.setButtonActive(button);
      });
    });

    // Listen for the global event to update active button state
    document.addEventListener('categoryFilterChange', (event) => {
      const { activeCategory } = event.detail;
      this.updateActiveButton(activeCategory);
    });
  }

  setButtonActive(targetButton) {
    const activeCategory = targetButton.dataset.targetUrl;
    const event = new CustomEvent('categoryFilterChange', {
      detail: { activeCategory },
      bubbles: true,
      composed: true,
    });
    document.dispatchEvent(event);
  }

  updateActiveButton(activeCategory) {
    this.filterButtons.forEach((button) => {
      if (button.dataset.targetUrl === activeCategory) {
        button.setAttribute('active', '');
      } else {
        button.removeAttribute('active');
      }
    });
  }

  switchCollectionContent(targetUrl) {
    fetch(targetUrl)
      .then((res) => res.text())
      .then((text) => {
        try {
          const html = new DOMParser().parseFromString(text, 'text/html');
          const sections = {};

          this.getSectionsToRender().forEach((section) => {
            const sectionElement = html.getElementById(section.id);
            if (sectionElement) {
              sections[section.id] = sectionElement.outerHTML;
            }
          });

          const parsedState = { sections };
          this.renderContents(parsedState);
          this.updateURL(targetUrl);
        } catch (error) {
          console.error('Failed to parse HTML:', error);
        }
      })
      .catch((error) =>
        console.error('Error fetching collection content:', error)
      );
  }

  renderContents(parsedState) {
    if (!parsedState || !parsedState.sections) {
      console.error('Invalid parsedState:', parsedState);
      return;
    }

    this.productId = parsedState.id;

    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.id
        ? document.getElementById(section.id)
        : document.querySelector(section.selector);

      if (sectionElement && parsedState.sections[section.id]) {
        const innerHTML = this.getSectionInnerHTML(
          parsedState.sections[section.id],
          section.selector
        );
        sectionElement.innerHTML = innerHTML;
        this.scrollTo(this.dataset.scrollTarget);
      } else {
        console.warn(
          `Section element for ${section.id} not found or missing content.`
        );
      }
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const section = parsed.querySelector(selector);
    return section ? section.innerHTML : '';
  }

  scrollTo(targetSelector) {
    if (!this.hasAttribute('data-scroll-target')) return;
    const container = document.querySelector(targetSelector);
    const targetTimeout = Number(this.dataset.scrollTimeout) || 0;

    if (this.hasAttribute('scroll-to-body')) {
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }, targetTimeout);
    } else {
      setTimeout(() => {
        container.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, targetTimeout);
    }
  }

  updateURL(url) {
    if (!this.hasAttribute('data-update-url')) return;
    window.history.replaceState({}, '', url);
  }

  getSectionsToRender() {
    return [
      {
        id: 'CollectionPageHeader',
        section: 'collection-banner',
        selector: '[data-section-api-content]',
      },
      {
        id: 'CollectionPageGrid',
        section: 'main-collection',
        selector: '[data-section-api-content]',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }
}

customElements.define('category-filters', CategoryFilters);

class HorizontalScrollWatcher {
  constructor(container, options = {}) {
    this.container = container;
    this.attrStart = options.attrStart || 'data-reached-start';
    this.attrEnd = options.attrEnd || 'data-reached-end';

    this._onScroll = this._onScroll.bind(this);
    this.container.addEventListener('scroll', this._onScroll);
    this._onScroll();
  }

  _onScroll() {
    const { scrollLeft, scrollWidth, clientWidth } = this.container;

    // Check if at start
    if (scrollLeft <= 0) {
      this.container.setAttribute(this.attrStart, 'true');
    } else {
      this.container.removeAttribute(this.attrStart);
    }

    // Check if at end
    if (scrollLeft + clientWidth >= scrollWidth) {
      this.container.setAttribute(this.attrEnd, 'true');
    } else {
      this.container.removeAttribute(this.attrEnd);
    }
  }

  disconnect() {
    this.container.removeEventListener('scroll', this._onScroll);
  }
}

// Usage example
const containers = document.querySelectorAll('[x-scroll-watcher]');
containers.forEach((container) => new HorizontalScrollWatcher(container));

import { ProductForm } from 'theme';

var ProductFormBundle = class extends ProductForm {
  #submitting = false;
  #delay = 300; // Default delay of 300ms
  _currencyFormatter = new Intl.NumberFormat(Shopify.locale, {
    style: 'currency',
    currency: Shopify.currency.active,
  });

  constructor(delay = 300) {
    super();
    this.#delay = delay;
    this.addEventListener('submit', this._onSubmit);
    this._addCheckboxListeners(); // New: Listen for checkbox changes
  }

  connectedCallback() {}

  getSelectedProducts() {
    const selectedProducts = [];
    this.querySelectorAll('input[name="id"]:checked').forEach((input) => {
      const variantId = input.value;
      const quantity = input.getAttribute('data-product-qty') || 1;
      selectedProducts.push({
        id: parseInt(variantId),
        quantity: parseInt(quantity),
        price: parseFloat(input.getAttribute('data-price')) || 0, // Capture price
      });
    });
    return selectedProducts;
  }

  async _onSubmit(event) {
    event.preventDefault();

    if (this.#submitting) return;

    if (!this.checkValidity()) {
      this.reportValidity();
      return;
    }

    const submitButtons = Array.from(this.elements).filter(
      (button) => button.type === 'submit'
    );
    submitButtons.forEach((submitButton) =>
      submitButton.setAttribute('aria-busy', 'true')
    );

    this.#submitting = true;

    const products = this.getSelectedProducts();

    if (products.length === 0) {
      console.warn('No products selected.');
      this.#submitting = false;
      submitButtons.forEach((submitButton) =>
        submitButton.removeAttribute('aria-busy')
      );
      return;
    }

    const sectionsToBundle = ['variant-added'];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:prepare-bundled-sections', {
        bubbles: true,
        detail: { sections: sectionsToBundle },
      })
    );

    const formData = new FormData();
    products.forEach((product, index) => {
      formData.append(`items[${index}][id]`, product.id);
      formData.append(`items[${index}][quantity]`, product.quantity);
    });

    formData.set('sections', sectionsToBundle.join(','));
    formData.set(
      'sections_url',
      `${Shopify.routes.root}variants/${this.id.value}`
    );

    try {
      const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
        body: formData,
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
        },
      });

      submitButtons.forEach((submitButton) =>
        submitButton.removeAttribute('aria-busy')
      );
      this.#submitting = false;

      const responseJson = await response.json();

      if (response.ok) {
        const cartContent = await (
          await fetch(`${Shopify.routes.root}cart.js`)
        ).json();

        cartContent['sections'] = responseJson['sections'] || [];

        if (this.closest('x-drawer')) {
          const relatedDrawer = this.closest('x-drawer');
          relatedDrawer.hide();

          setTimeout(() => {
            this._dispatchCartChange(cartContent, responseJson);
          }, this.#delay);
        } else {
          this._dispatchCartChange(cartContent, responseJson);
        }

        if (
          window.themeVariables.settings.cartType === 'page' ||
          window.themeVariables.settings.pageType === 'cart'
        ) {
          return (window.location.href = `${Shopify.routes.root}cart`);
        }
      } else {
        console.error('Error in Shopify response:', responseJson);
        this.dispatchEvent(
          new CustomEvent('cart:error', {
            bubbles: true,
            detail: {
              error: responseJson['description'] || 'Unknown error occurred',
            },
          })
        );
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      }
    } catch (error) {
      console.error('Error adding to cart:', error);
      this.#submitting = false;
      submitButtons.forEach((submitButton) =>
        submitButton.removeAttribute('aria-busy')
      );
    }
  }

  _dispatchCartChange(cartContent, responseJson) {
    this.dispatchEvent(
      new CustomEvent('variant:add', {
        bubbles: true,
        detail: {
          items: responseJson.hasOwnProperty('items')
            ? responseJson['items']
            : [responseJson],
          cart: cartContent,
        },
      })
    );

    document.documentElement.dispatchEvent(
      new CustomEvent('cart:change', {
        bubbles: true,
        detail: {
          baseEvent: 'variant:add',
          cart: cartContent,
        },
      })
    );
  }

  // New: Add event listeners to checkboxes
  _addCheckboxListeners() {
    this.querySelectorAll('input[name="id"]').forEach((checkbox) => {
      checkbox.addEventListener('change', (event) => {
        const buyButton = this.querySelector('button[type="submit"]');
        const checkboxes = this.querySelectorAll('input[name="id"]');
        const checkedCount = [...checkboxes].filter((cb) => cb.checked).length;

        if (checkedCount === 0) {
          // event.target.checked = true;
          buyButton.textContent =
            window.themeVariables.strings.formSelectProducts;
          buyButton.disabled = true;
        } else if (checkedCount == 1) {
          buyButton.textContent =
            window.themeVariables.strings.addToCartButtonText;
          buyButton.disabled = false;
        } else {
          buyButton.innerHTML = window.themeVariables.strings.buyAllItemsFor;
        }
        this._updateTotalData();
        setTimeout(() => {
          this._updateTotalData();
        }, 1000);
      });
    });
  }

  // New: Update the total quantity and price dynamically
  _updateTotalData() {
    const selectedProducts = this.getSelectedProducts();
    let totalQty = 0;
    let totalPrice = 0;

    selectedProducts.forEach((product) => {
      totalQty += product.quantity;
      totalPrice += product.quantity * product.price;
    });

    const qtyContainers = this.querySelectorAll('[data-total-qty]');
    const priceContainers = this.querySelectorAll('[data-total-price]');

    if (qtyContainers) {
      qtyContainers.forEach((container) => {
        container.textContent = totalQty;
      });
    }

    if (priceContainers) {
      priceContainers.forEach((container) => {
        container.textContent = this._currencyFormatter.format(
          totalPrice / 100
        ); // Format price based on currency
      });
    }
  }
};

// Define the custom element for ProductFormBundle
if (!window.customElements.get('product-form-bundle')) {
  window.customElements.define('product-form-bundle', ProductFormBundle, {
    extends: 'form',
  });
}

class CheckboxGroupLimiter {
  constructor() {
    this.handleCheckboxChange = this.handleCheckboxChange.bind(this); // Bind once
    this.init();
  }

  init() {
    document.querySelectorAll('[data-checkbox-group]').forEach((group) => {
      group.removeEventListener('change', this.handleCheckboxChange);
      group.addEventListener('change', this.handleCheckboxChange);
    });
  }

  updateGroupCounters(counters, value) {
    if (!counters || !counters.length) return;
    counters.forEach((counter) => {
      counter.textContent = value;
    });
  }

  handleCheckboxChange(event) {
    const group = event.target.closest('[data-checkbox-group]');
    const groupCounters = group.querySelectorAll('[data-input-counter]');
    const threshold = parseInt(group.getAttribute('data-threshold'), 10);
    const disableBlocked = group.hasAttribute('data-disable-blocked');
    const checkboxes = group.querySelectorAll('input[type="checkbox"]');
    const checked = [...checkboxes].filter((cb) => cb.checked);
    const checkedCount = checked.length;

    if (
      event.target.checked &&
      checkedCount > threshold &&
      !event.target.hasAttribute('data-locked')
    ) {
      event.preventDefault();
      event.target.checked = false;
      return;
    }

    if (disableBlocked) {
      checkboxes.forEach((cb) => {
        if (
          cb.hasAttribute('data-locked') ||
          cb.hasAttribute('data-cart-disabled')
        )
          return;

        if (!cb.checked) {
          cb.disabled = checkedCount >= threshold;
        } else {
          cb.disabled = false;
        }
      });
    }

    this.updateGroupCounters(groupCounters, checkedCount);
  }
}

new CheckboxGroupLimiter();

class SiteTooltip extends HTMLElement {
  constructor() {
    super();
    this.tooltipText = this.getAttribute('text') || 'Tooltip text';
    this.tooltipElement = null;
    this.isVisible = false;
    this.isSticky = this.hasAttribute('data-sticky');
    this.isTouchDevice =
      'ontouchstart' in window || navigator.maxTouchPoints > 0; // Detect if it's a mobile/touch device
  }

  connectedCallback() {
    this.addEventListener('mouseenter', this.showTooltip.bind(this));
    this.addEventListener('mouseleave', this.hideTooltip.bind(this)); // Keep this event
    window.addEventListener('scroll', this.hideTooltip.bind(this));
    this.addEventListener('touchstart', this.toggleTooltip.bind(this));

    // Handle window resizing
    window.addEventListener('resize', this.positionTooltip.bind(this));

    if (this.isSticky) {
      this.showTooltip();
    }
  }

  toggleTooltip(event) {
    event.preventDefault();
    if (this.isVisible) {
      this.hideTooltip();
    } else {
      this.showTooltip();
    }
  }

  showTooltip() {
    if (this.tooltipElement) return;

    this.tooltipElement = document.createElement('div');
    this.tooltipElement.className = 'tooltip-box';
    this.tooltipElement.innerHTML = this.tooltipText; // Allow HTML content

    document.body.appendChild(this.tooltipElement);

    // Initially position the tooltip
    this.positionTooltip();
  }

  positionTooltip() {
    if (!this.tooltipElement) return;

    const rect = this.getBoundingClientRect();
    const tooltipRect = this.tooltipElement.getBoundingClientRect();
    const windowWidth = window.innerWidth;
    const windowHeight = window.innerHeight;

    let top = rect.bottom + 8 + window.scrollY; // Force tooltip to appear below
    let left =
      rect.left + rect.width / 2 - tooltipRect.width / 2 + window.scrollX;

    const margin = 15; // 15px margin from edges

    // Ensure the tooltip doesn't go off the left edge
    if (left < margin) {
      left = margin + window.scrollX; // Keep 15px margin from left edge
    }

    // Ensure the tooltip doesn't go off the right edge
    if (left + tooltipRect.width > windowWidth - margin) {
      left = windowWidth - tooltipRect.width - margin + window.scrollX; // Keep 15px margin from right edge
    }

    // Ensure the tooltip doesn't go off the bottom edge
    if (top + tooltipRect.height > windowHeight - margin) {
      top = rect.top - tooltipRect.height - 8 + window.scrollY; // Revert to top if bottom is not enough space
    }

    this.tooltipElement.style.top = `${top}px`;
    this.tooltipElement.style.left = `${left}px`;

    this.tooltipElement.style.visibility = 'visible';
    this.tooltipElement.style.opacity = '1';
    this.isVisible = true;

    if (this.isSticky) {
      this.tooltipElement.classList.add('sticky');
    }
  }

  hideTooltip() {
    if (this.tooltipElement && !this.isSticky) {
      this.tooltipElement.style.visibility = 'hidden';
      this.tooltipElement.style.opacity = '0';

      setTimeout(() => {
        if (this.tooltipElement) {
          this.tooltipElement.remove();
          this.tooltipElement = null;
        }
        this.isVisible = false;
      }, 300);
    }
  }

  disconnectedCallback() {
    this.removeEventListener('mouseenter', this.showTooltip);
    this.removeEventListener('mouseleave', this.hideTooltip); // Keep this event
    this.removeEventListener('touchstart', this.toggleTooltip);
    window.removeEventListener('resize', this.positionTooltip.bind(this));
  }
}

customElements.define('site-tooltip', SiteTooltip);

class ReadMore {
  constructor(selector, threshold = 0.2) {
    this.selector = selector;
    this.threshold = threshold;
    this.init();
    this.handleResize();
  }

  init() {
    this.elements = document.querySelectorAll(this.selector);
    this.elements.forEach((el) => {
      if (!el.dataset.maxLines) return;

      const maxLines = parseInt(el.dataset.maxLines, 10);
      const computedStyle = window.getComputedStyle(el);
      let lineHeight = parseFloat(computedStyle.lineHeight);

      if (isNaN(lineHeight) || computedStyle.lineHeight === 'normal') {
        lineHeight = 1.2 * parseFloat(computedStyle.fontSize);
      }

      const maxHeight = maxLines * lineHeight;
      el.style.maxHeight = 'none';
      const realHeight = el.scrollHeight;

      // Calculate if Read More is needed
      if (realHeight <= maxHeight * (1 + this.threshold)) return;

      el.setAttribute('aria-expanded', 'false');
      this.truncate(el, maxHeight);
    });
  }

  truncate(el, maxHeight) {
    const existingBtn = el.nextElementSibling;
    if (existingBtn && existingBtn.classList.contains('js-read-more-toggle')) {
      existingBtn.remove();
    }

    const readMoreBtn = document.createElement('button');
    readMoreBtn.textContent =
      window.themeVariables.strings.accessibilityReadMore;
    readMoreBtn.classList.add('js-read-more-toggle', 'semibold', 'link');

    el.classList.add('js-read-more-content');
    el.style.maxHeight = `${maxHeight}px`;
    el.style.overflow = 'hidden';
    el.style.position = 'relative';
    el.style.transition = 'max-height 0.25s ease-in-out';
    el.setAttribute('aria-expanded', 'false');

    el.parentNode.insertBefore(readMoreBtn, el.nextSibling);

    readMoreBtn.addEventListener('click', () => {
      const isExpanded = el.getAttribute('aria-expanded') === 'true';
      el.style.maxHeight = isExpanded ? `${maxHeight}px` : 'none';
      el.setAttribute('aria-expanded', isExpanded ? 'false' : 'true');
      readMoreBtn.textContent = isExpanded
        ? window.themeVariables.strings.accessibilityReadMore
        : window.themeVariables.strings.accessibilityReadLess;
    });
  }

  handleResize() {
    window.addEventListener('resize', () => {
      this.elements.forEach((el) => {
        el.style.maxHeight = 'none';

        // Remove existing buttons to avoid duplicates
        const existingBtn = el.nextElementSibling;
        if (
          existingBtn &&
          existingBtn.classList.contains('js-read-more-toggle')
        ) {
          existingBtn.remove();
        }
      });

      this.init();
    });
  }
}

window.addEventListener('load', () => {
  new ReadMore('[data-max-lines]', 0.65);
});

class FreeGiftManager {
  constructor() {
    this.cart = null;
    this.previousCart = null;
    this.totalCountTexts = document.querySelectorAll('.js-free-gift-count');
  }

  async init() {
    this.cart = await this.fetchCart();
    this.previousCart = structuredClone(this.cart);
    this.updateGiftCount();

    document.addEventListener('cart:change', (event) => {
      this.previousCart = structuredClone(this.cart);
      this.cart = event.detail.cart;
      this.updateGiftCount();
      this.cleanupOrphanedFreeGifts();
    });

    this.updateGiftCount();
  }

  async fetchCart() {
    try {
      const res = await fetch(`${Shopify.routes.root}cart.js`);
      return await res.json();
    } catch (err) {
      console.error('❌ Failed to fetch cart:', err);
      return { items: [] };
    }
  }

  updateGiftCount() {
    const giftCount =
      this.cart?.items?.filter(
        (item) => item?.properties?._free_gift === 'true'
      ).length || 0;

    this.totalCountTexts.forEach((el) => {
      el.textContent = giftCount;
    });
  }

  getRemovedMainProducts() {
    const oldItems = this.previousCart?.items || [];
    const newItems = this.cart?.items || [];

    return oldItems.filter((oldItem) => {
      const isMain = oldItem.properties?._has_free_gifts === 'true';

      const stillExists = newItems.some(
        (newItem) =>
          newItem.product_id === oldItem.product_id &&
          !newItem.properties?._free_gift
      );

      return isMain && !stillExists;
    });
  }

  parseGiftIds(raw) {
    if (typeof raw === 'string') {
      return raw
        .split(',')
        .map((id) => id.trim())
        .filter(Boolean);
    } else if (Array.isArray(raw)) {
      return raw.map((id) => String(id).trim()).filter(Boolean);
    } else if (typeof raw === 'number') {
      return [String(raw)];
    }
    return [];
  }

  async cleanupOrphanedFreeGifts() {
    const removedProducts = this.getRemovedMainProducts();
    if (removedProducts.length === 0) return;

    const giftKeysToRemove = new Set();

    for (const mainItem of removedProducts) {
      const productId = mainItem.product_id;
      const relatedLineItemKey = mainItem.key?.split(':')[0];
      const giftIds = this.parseGiftIds(
        mainItem.properties?._assigned_free_gift_ids
      );

      this.cart.items.forEach((item) => {
        const props = item.properties || {};
        const isGift = props._free_gift === 'true';
        const matchesThisProduct =
          props._related_line_item_id === relatedLineItemKey ||
          props._unique_id?.startsWith(`${productId}-`) ||
          giftIds.includes(String(item.variant_id));

        if (isGift && matchesThisProduct && item.key) {
          giftKeysToRemove.add(item.key);
        }
      });
    }

    if (!giftKeysToRemove.size) return;

    console.log(`🧼 Removing ${giftKeysToRemove.size} orphaned gifts`);

    for (const key of giftKeysToRemove) {
      try {
        const res = await fetch(`${Shopify.routes.root}cart/change.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: JSON.stringify({ id: key, quantity: 0 }),
        });

        if (!res.ok) {
          const error = await res.json();
          console.warn(`❌ Could not remove gift [${key}]:`, error);
        } else {
          console.log(`✅ Removed gift: ${key}`);
        }
      } catch (err) {
        console.error(`🚨 Network error removing gift [${key}]`, err);
      }
    }

    document.dispatchEvent(new CustomEvent('cart:refresh'));

    try {
      const freshCart = await this.fetchCart();
      document.dispatchEvent(
        new CustomEvent('cart:change', {
          bubbles: true,
          detail: { baseEvent: 'free-gift-cleanup', cart: freshCart },
        })
      );
    } catch (err) {
      console.warn('⚠️ Failed to trigger cart:change after gift cleanup');
    }
  }
}

const freeGiftManager = new FreeGiftManager();
freeGiftManager.init();

class FreeGiftItem extends HTMLElement {
  constructor() {
    super();
    this.cart = null;
    this.limit = window.themeVariables?.freeGiftsLimitPerProduct ?? 3;
    this.uniqueId = this.getUniqueId();
    this.hostProductId = this.getHostProductId();
  }

  async connectedCallback() {
    this.cart = await createCartPromise();
    this.toggleInputState();

    document.addEventListener('cart:change', (event) => {
      this.cart = event.detail.cart;
      requestAnimationFrame(() => this.toggleInputState());
    });

    setTimeout(() => this.toggleInputState(), 1000);
  }

  getUniqueId() {
    const match = this.id.match(/^free-gift-item-(\d+-\d+)$/);
    return match ? match[1] : null;
  }

  getHostProductId() {
    const match = this.uniqueId?.match(/^(\d+)-\d+$/);
    return match ? match[1] : null;
  }

  isInCart() {
    return this.cart?.items?.some(
      (item) =>
        item.properties?._free_gift === 'true' &&
        item.properties?._unique_id === this.uniqueId
    );
  }

  getGiftCountForHost() {
    return (
      this.cart?.items?.filter(
        (item) =>
          item.properties?._free_gift === 'true' &&
          item.properties?._unique_id?.startsWith(`${this.hostProductId}-`)
      ).length || 0
    );
  }

  toggleInputState() {
    const input = this.querySelector('input');
    const card = this;

    if (!input || !this.uniqueId || !this.hostProductId) return;

    const inCart = this.isInCart();
    const hostCount = this.getGiftCountForHost();

    if (inCart || hostCount >= this.limit) {
      input.disabled = true;
      input.setAttribute('data-cart-disabled', 'true');

      if (inCart) {
        input.checked = true;
        input.setAttribute('data-locked', 'true');
      } else {
        input.checked = false;
        input.removeAttribute('data-locked');
      }

      card.classList.add('is-disabled');
    } else {
      input.disabled = false;
      input.checked = false;
      input.removeAttribute('data-cart-disabled');
      input.removeAttribute('data-locked');
      card.classList.remove('is-disabled');
    }
  }
}

customElements.define('free-gift-item', FreeGiftItem);
function bindDialogToggles(scope = document) {
  const toggleButtons = scope.querySelectorAll(
    '[aria-controls^="FreeGiftsDrawer-"]'
  );

  toggleButtons.forEach((button) => {
    button.removeEventListener('click', handleDialogToggle); // Clean up old
    button.addEventListener('click', handleDialogToggle);
  });
}

function handleDialogToggle(event) {
  const targetId = event.currentTarget.getAttribute('aria-controls');
  const dialog = document.getElementById(targetId);
  if (dialog && typeof dialog.showModal === 'function') {
    dialog.showModal();
  } else if (dialog) {
    dialog.setAttribute('open', '');
  }
}

// Initial load
bindDialogToggles();

// Rebind after cart re-renders
document.addEventListener('cart:change', () => {
  const cartDrawer = document.querySelector('#cart-drawer');
  if (cartDrawer) bindDialogToggles(cartDrawer);
});
